import PropTypes from 'prop-types';
import { dayLabel } from './mediaPlanningView';

// Frozen first column: opaque so scrolled data can't bleed through, with a soft
// right shadow to lift it above the scrolling cells.
export const FROZEN = 'sticky left-0 bg-white shadow-[8px_0_12px_-8px_rgba(15,23,42,0.16)]';

export const isWeekend = (weekday) => weekday === 'sáb' || weekday === 'dom';

// Shared day-column header (weekday over day number) + the frozen corner cell.
// Today's column is highlighted so it stands out from past/future.
export function DayHeader({ days, firstLabel, today }) {
  return (
    <thead>
      <tr>
        <th className={`${FROZEN} z-30 border-b border-gray-200 px-4 py-2.5 text-left text-xs font-medium uppercase tracking-wide text-gray-400`}>
          {firstLabel}
        </th>
        {days.map((d) => {
          const { day, weekday } = dayLabel(d.date);
          const isToday = d.date === today;
          const bg = isToday ? 'bg-indigo-50' : isWeekend(weekday) ? 'bg-gray-50/70' : '';
          return (
            <th key={d.date} className={`border-b border-gray-200 px-3 py-2 text-center font-normal ${bg}`}>
              <div className={`text-[11px] leading-tight ${isToday ? 'text-indigo-500' : 'text-gray-400'}`}>{weekday}</div>
              <div className={`text-[13px] font-medium ${isToday ? 'text-indigo-700' : 'text-gray-700'}`}>{day}</div>
            </th>
          );
        })}
      </tr>
    </thead>
  );
}

DayHeader.propTypes = { days: PropTypes.array.isRequired, firstLabel: PropTypes.string, today: PropTypes.string };
